import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ScheduledDropResponse } from './get-scheduled-drops';

export interface CreateScheduledDropParams {
  studentId: string;
  enrollmentId: string;
  scheduledDropDate: string;
  dropReason: string;
  shouldRefund?: boolean;
}

export const createScheduledDropAPI = async (
  params: CreateScheduledDropParams,
): Promise<ScheduledDropResponse> => {
  const response = await baseAPI.post<ScheduledDropResponse>(
    '/scheduled-drops',
    params,
  );
  return response.data;
};

export const useCreateScheduledDrop = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createScheduledDropAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.SCHEDULED_DROPS] });
    },
  });
};
